/** Shared icon class for command palette items. */
export const commandItemIconClass = "size-4 shrink-0 text-content-secondary";

/** Icon class for workflow/automation icons that need flex centering. */
export const commandItemIconClassCentered = "size-4 shrink-0 text-content-secondary flex items-center justify-center";

/** Port names that are internal system ports and should be hidden from users. */
export const SYSTEM_PORT_NAMES = new Set(["ona-swe-agent", "codex-exec-agent", "VS Code Server"]);
